/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type FindAllDashboards200Response,
    FindAllDashboards200ResponseFromJSON,
    FindAllDashboards200ResponseToJSON,
} from '../models/FindAllDashboards200Response';
import {
    type OmniGenerateIFrameUrl201Response,
    OmniGenerateIFrameUrl201ResponseFromJSON,
    OmniGenerateIFrameUrl201ResponseToJSON,
} from '../models/OmniGenerateIFrameUrl201Response';
import {
    type OmniGenerateIFrameUrlForReportBuilderRequest,
    OmniGenerateIFrameUrlForReportBuilderRequestFromJSON,
    OmniGenerateIFrameUrlForReportBuilderRequestToJSON,
} from '../models/OmniGenerateIFrameUrlForReportBuilderRequest';
import {
    type OmniGenerateIFrameUrlRequest,
    OmniGenerateIFrameUrlRequestFromJSON,
    OmniGenerateIFrameUrlRequestToJSON,
} from '../models/OmniGenerateIFrameUrlRequest';

export interface OmniGenerateIFrameUrlOperationRequest {
    /**
     * 
     */
    omniGenerateIFrameUrlRequest: OmniGenerateIFrameUrlRequest;
}

export interface OmniGenerateIFrameUrlForReportBuilderOperationRequest {
    /**
     * 
     */
    omniGenerateIFrameUrlForReportBuilderRequest: OmniGenerateIFrameUrlForReportBuilderRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Creates request options for findAllDashboards without sending the request
     */
    async findAllDashboardsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dashboards`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get dashboards
     */
    async findAllDashboardsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllDashboards200Response>> {
        const requestOptions = await this.findAllDashboardsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllDashboards200ResponseFromJSON(jsonValue));
    }

    /**
     * Get dashboards
     */
    async findAllDashboards(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllDashboards200Response> {
        const response = await this.findAllDashboardsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for omniGenerateIFrameUrl without sending the request
     */
    async omniGenerateIFrameUrlRequestOpts(requestParameters: OmniGenerateIFrameUrlOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['omniGenerateIFrameUrlRequest'] == null) {
            throw new runtime.RequiredError(
                'omniGenerateIFrameUrlRequest',
                'Required parameter "omniGenerateIFrameUrlRequest" was null or undefined when calling omniGenerateIFrameUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/omni/iframe-url`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OmniGenerateIFrameUrlRequestToJSON(requestParameters['omniGenerateIFrameUrlRequest']),
        };
    }

    /**
     * Generate an Omni iframe URL
     */
    async omniGenerateIFrameUrlRaw(requestParameters: OmniGenerateIFrameUrlOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OmniGenerateIFrameUrl201Response>> {
        const requestOptions = await this.omniGenerateIFrameUrlRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OmniGenerateIFrameUrl201ResponseFromJSON(jsonValue));
    }

    /**
     * Generate an Omni iframe URL
     */
    async omniGenerateIFrameUrl(requestParameters: OmniGenerateIFrameUrlOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OmniGenerateIFrameUrl201Response> {
        const response = await this.omniGenerateIFrameUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for omniGenerateIFrameUrlForReportBuilder without sending the request
     */
    async omniGenerateIFrameUrlForReportBuilderRequestOpts(requestParameters: OmniGenerateIFrameUrlForReportBuilderOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['omniGenerateIFrameUrlForReportBuilderRequest'] == null) {
            throw new runtime.RequiredError(
                'omniGenerateIFrameUrlForReportBuilderRequest',
                'Required parameter "omniGenerateIFrameUrlForReportBuilderRequest" was null or undefined when calling omniGenerateIFrameUrlForReportBuilder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/omni/iframe-url/report-builder`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OmniGenerateIFrameUrlForReportBuilderRequestToJSON(requestParameters['omniGenerateIFrameUrlForReportBuilderRequest']),
        };
    }

    /**
     * Generate an Omni iframe URL for report builder
     */
    async omniGenerateIFrameUrlForReportBuilderRaw(requestParameters: OmniGenerateIFrameUrlForReportBuilderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OmniGenerateIFrameUrl201Response>> {
        const requestOptions = await this.omniGenerateIFrameUrlForReportBuilderRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OmniGenerateIFrameUrl201ResponseFromJSON(jsonValue));
    }

    /**
     * Generate an Omni iframe URL for report builder
     */
    async omniGenerateIFrameUrlForReportBuilder(requestParameters: OmniGenerateIFrameUrlForReportBuilderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OmniGenerateIFrameUrl201Response> {
        const response = await this.omniGenerateIFrameUrlForReportBuilderRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
